var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShieldUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39.88 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bdccd4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-shield-user") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.61,29.41c.47-.3.91-.56,1.32-.8l.4-.25c-.08-.24-.16-.48-.23-.74A7.54,7.54,0,0,1,19,25.25,20.7,20.7,0,0,1,16.5,26.8l-2.16,1a6.81,6.81,0,0,1-.66.26V16H3.23V7.68A22.31,22.31,0,0,0,13.68,3.54V16h6.64a9.52,9.52,0,0,1,1.21-1.53,10.09,10.09,0,0,1,1.88-1.56,8.3,8.3,0,0,1,2-1,7.26,7.26,0,0,1,2-.39h0V6.83a2.24,2.24,0,0,0-2.1-2.3l-.52-.07a20.08,20.08,0,0,1-2.1-.33A20.27,20.27,0,0,1,15.33.66,2.63,2.63,0,0,0,13.76,0a2.63,2.63,0,0,0-1.51.59C8.68,3,5.53,4.26,2.31,4.47A2.21,2.21,0,0,0,0,6.89v9.92a10.29,10.29,0,0,0,.26,2.75,12.91,12.91,0,0,0,3.55,6.17,23.91,23.91,0,0,0,9.06,5.58,3.29,3.29,0,0,0,.79.13,2.19,2.19,0,0,0,1-.2l1-.39A19.18,19.18,0,0,0,18,29.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.34,34.22a39.43,39.43,0,0,0-6.36-4,.21.21,0,0,1-.12-.19V28a7.4,7.4,0,0,0,.59-1.91c.27.19.73.09,1.23-1.68.41-1.43.16-1.92-.19-2C34.63,16.91,32,16.73,32,16.73A3.67,3.67,0,0,0,30.6,15.4a4.86,4.86,0,0,0-2.94-.62,4.24,4.24,0,0,0-1.17.22h0a5.29,5.29,0,0,0-1.29.66,7,7,0,0,0-1.33,1.1,5.35,5.35,0,0,0-1.43,2.51,4.71,4.71,0,0,0,.12,2.8c-.47,0-1,.23-.5,2.07.38,1.34.74,1.72,1,1.75a6.8,6.8,0,0,0,.82,2.4v1.76a.23.23,0,0,1-.12.2,40.08,40.08,0,0,0-6.36,4,4,4,0,0,0-1.54,3.17v1.84a.75.75,0,0,0,.75.75H39.12a.75.75,0,0,0,.75-.75V37.4A4,4,0,0,0,38.34,34.22Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShieldUser);
export default __webpack_public_path__ + "static/media/icon-shield-user.ccc8ba5f0b7017c1b64f8f740acf5073.svg";
export { ForwardRef as ReactComponent };